import { RESET } from '../../constants.js';
export function isResetValue(value) {
    return value === RESET;
}
//# sourceMappingURL=isResetValue.js.map